import { observer } from 'mobx-react-lite';
import React, { useEffect, useRef, useState } from 'react';
import { TabPanel } from 'react-tabs';
import { colors } from '../../../../../../../../../../colorVars';
import { addExitTactic } from '../../../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/addExitTactic';
import { useWebsocketStore } from '../../../../../../../../../../stores/websocketStore/websocketProvider';
import TextButton from '../../../../../../../../../atomic/buttons/textButton/TextButton';
import { EditableTableFieldNoOnBlurUpdate } from '../../../../../../../../../atomic/inputs/editableTableField/EditableFieldNoOnBlurUpdate';
import { TableSelect } from '../../../../../../../../../atomic/inputs/tableSelect/TableSelect';
import { Body3, fontSizes } from '../../../../../../../../../atomic/text/Text';
import { ratchetBracketValidation } from '../../../../../../../../../forms/tradeplans/AddTradePlan/DataValidation';
import { IndividualPanelHeader } from '../../../../individualTacticPanels/IndividualPanelHeader';
import style from './IndividualAddTacticPanel.module.css';
const perBracketLabels = {
  PROFIT: 'Num. of Brackets',
  QUANTITY: 'Qty. per Bracket',
  PERCENT: '% per Bracket',
};
const targetLabels = {
  PROFIT: 'Target Profit',
  QUANTITY: 'Target Price',
  PERCENT: 'Target Price',
};
const stopLabels = {
  PROFIT: 'Stop Profit',
  QUANTITY: 'Stop Price',
  PERCENT: 'Stop Price',
};
const trailLabels = {
  PROFIT: 'Trail Pct.',
  QUANTITY: 'Trail Qty.',
  PERCENT: 'Trail Pct.',
};

export const AddRatchetBracketTacticPanel = observer(
  // eslint-disable-next-line no-unused-vars
  ({ tradePlanId, softOrderId, addTab, ...rest }) => {
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId];
    const [headerText, setHeaderText] = useState('Add Ratchet Bracket');
    const [headerTextColor, setHeaderTextColor] = useState(colors.lightGrey);
    const [details, setDetails] = useState({
      mode: 'EQUAL_INTERVAL',
      qtyBasis: 'QUANTITY',
      targetPerBracket: 0.1,
      stopPerBracket: 0.1,
      qtyBasisValuePerBracket: 0,
      trailQtyBasisValue: 0,
    });
    const timeoutRef = useRef(null);

    const addTactic = () => {
      const detailsCopy = { ...details };
      if (details.qtyBasis === 'PERCENT')
        detailsCopy.qtyBasisValuePerBracket =
          details.qtyBasisValuePerBracket / 100;
      if (details.qtyBasis !== 'QUANTITY')
        detailsCopy.trailQtyBasisValue = details.trailQtyBasisValue / 100;
      const validationResult = ratchetBracketValidation(detailsCopy);
      if (validationResult[0] === false) {
        setHeaderText(validationResult[1]);
        setHeaderTextColor(colors.red);
        const timer = setTimeout(() => {
          setHeaderText('Add Ratchet Bracket');
          setHeaderTextColor(colors.lightGrey);
        }, 2000);
        timeoutRef.current = timer;
      } else {
        addExitTactic(tradePlanId, {
          tactic: 'RATCHET_BRACKET',
          details: detailsCopy,
        });
        setHeaderText('Ratchet Bracket Added');
        setHeaderTextColor(colors.green);
        const timer = setTimeout(() => {
          setHeaderText('Add Ratchet Bracket');
          setHeaderTextColor(colors.lightGrey);
        }, 2000);
        timeoutRef.current = timer;
      }
    };

    useEffect(() => {
      return () => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
      };
    }, []);

    return (
      <TabPanel {...rest}>
        <div className={style.tableContainer}>
          <table className={style.table}>
            <IndividualPanelHeader />
            <tbody>
              <tr>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Qty. Basis
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <div className={style.inputWrapper}>
                    <TableSelect
                      margin="6px 0 0 0"
                      backgroundColor="inherit"
                      color={colors.lightGrey}
                      value={details.qtyBasis}
                      onChange={(value) => {
                        setDetails((prev) => ({ ...prev, qtyBasis: value }));
                      }}
                      options={[
                        { label: 'Quantity', value: 'QUANTITY' },
                        { label: 'Profit', value: 'PROFIT' },
                        { label: 'Percent', value: 'PERCENT' },
                      ]}
                    />
                  </div>
                </td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    {targetLabels[details.qtyBasis]}
                  </Body3>
                </td>

                <td className={style.inputTd}>
                  <div className={style.inputWrapper}>
                    <Body3
                      fontWeight={700}
                      color={colors.lightGrey}
                      margin="3px 3px 0 0"
                    >
                      $
                    </Body3>
                    <EditableTableFieldNoOnBlurUpdate
                      color={colors.lightGrey}
                      backgroundColor="inherit"
                      fontSize={fontSizes.body3}
                      value={details.targetPerBracket}
                      setValue={(newValue) =>
                        setDetails((prev) => ({
                          ...prev,
                          targetPerBracket: newValue,
                        }))
                      }
                    />
                  </div>
                </td>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    {stopLabels[details.qtyBasis]}
                  </Body3>
                </td>

                <td className={style.inputTd}>
                  <div className={style.inputWrapper}>
                    <Body3
                      fontWeight={700}
                      color={colors.lightGrey}
                      margin="3px 3px 0 0"
                    >
                      $
                    </Body3>
                    <EditableTableFieldNoOnBlurUpdate
                      color={colors.lightGrey}
                      backgroundColor="inherit"
                      fontSize={fontSizes.body3}
                      value={details.stopPerBracket}
                      setValue={(newValue) =>
                        setDetails((prev) => ({
                          ...prev,
                          stopPerBracket: newValue,
                        }))
                      }
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    {perBracketLabels[details.qtyBasis]}
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <div className={style.inputWrapper}>
                    {details.qtyBasis !== 'PERCENT' ? (
                      <Body3
                        fontWeight={700}
                        color={colors.lightGrey}
                        margin="3px 3px 0 0"
                      >
                        #
                      </Body3>
                    ) : null}
                    <EditableTableFieldNoOnBlurUpdate
                      color={colors.lightGrey}
                      backgroundColor="inherit"
                      fontSize={fontSizes.body3}
                      value={details.qtyBasisValuePerBracket}
                      setValue={(newValue) =>
                        setDetails((prev) => ({
                          ...prev,
                          qtyBasisValuePerBracket: newValue,
                        }))
                      }
                    />
                    {details.qtyBasis === 'PERCENT' ? (
                      <Body3
                        fontWeight={700}
                        color={colors.lightGrey}
                        margin="3px 3px 0 0"
                      >
                        %
                      </Body3>
                    ) : null}
                  </div>
                </td>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    {trailLabels[details.qtyBasis]}
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <div className={style.inputWrapper}>
                    {details.qtyBasis === 'QUANTITY' ? (
                      <Body3
                        fontWeight={700}
                        color={colors.lightGrey}
                        margin="3px 3px 0 0"
                      >
                        #
                      </Body3>
                    ) : null}
                    <EditableTableFieldNoOnBlurUpdate
                      color={colors.lightGrey}
                      backgroundColor="inherit"
                      fontSize={fontSizes.body3}
                      value={details.trailQtyBasisValue}
                      setValue={(newValue) =>
                        setDetails((prev) => ({
                          ...prev,
                          trailQtyBasisValue: newValue,
                        }))
                      }
                    />
                    {details.qtyBasis !== 'QUANTITY' ? (
                      <Body3
                        fontWeight={700}
                        color={colors.lightGrey}
                        margin="3px 3px 0 0"
                      >
                        %
                      </Body3>
                    ) : null}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <header className={style.header}>
            <Body3 color={headerTextColor} fontWeight={700}>
              {headerText}
            </Body3>
            <TextButton
              disabled={tradePlan.exitTactics['RATCHET_BRACKET']}
              color={colors.lightGrey}
              backgroundColor={
                tradePlan.exitTactics['RATCHET_BRACKET']
                  ? colors.grey
                  : colors.blue
              }
              fontSize="small"
              clickHandler={addTactic}
              width="20%"
              height="50%"
            >
              Add
            </TextButton>
          </header>
        </div>
      </TabPanel>
    );
  }
);

AddRatchetBracketTacticPanel.tabsRole = 'TabPanel';
